import React from 'react';

const Controller = () => {
  React.useEffect(() => {
    // Side Effects Here
  }, []);

  return null;
};

export default Controller;
